class ContentApiParameters {
  generate(parameters) {
    const queryParameters = {
      ...parameters
    };
    const filteredQueryParameters = this.filterEmptyParameters(queryParameters);

    return this.buildQueryString(filteredQueryParameters);
  }

  filterEmptyParameters(parameters) {
    const queryParameters = {};

    Object.keys(parameters).forEach(key => {
      if (parameters[key]) {
        queryParameters[key] = parameters[key];
      }
    });

    return queryParameters;
  }

  buildQueryString(queryParameters) {
    if (Object.keys(queryParameters).length === 0) {
      return "";
    }

    let queryString = "?";

    for (const parameter in queryParameters) {
      if (queryString === "?") {
        queryString = `${queryString}${parameter}=${queryParameters[parameter]}`;
      } else {
        queryString = `${queryString}&${parameter}=${queryParameters[parameter]}`;
      }
    }

    return queryString;
  }
}
export default new ContentApiParameters();
